import { Stack } from '@mui/material';
import { BookADemoButton } from './BookADemoButton';
import { ContentWithImage } from './ContentWithImage';
import { PageTitle } from './PageTitle';
import type { PageblockData } from '../../../../../constants/pageblockTypes';
import type { ReactNode } from 'react';

export const PageBlockLayout = ({
  pageblockData,
  header,
}: {
  pageblockData: PageblockData;
  header: ReactNode;
}) => {
  const { pageTitle, section1, section2, section3, section4 } = pageblockData;

  return (
    <Stack alignItems="center">
      {header}
      <PageTitle pageTitle={pageTitle} />
      <ContentWithImage {...section1} imgPosition="left" pt="0" />
      <ContentWithImage {...section2} imgPosition="right" />
      <ContentWithImage {...section3} imgPosition="left" />
      {section4 && <ContentWithImage {...section4} imgPosition="right" />}
      <BookADemoButton />
    </Stack>
  );
};
